import goals from "../../../../src/components/content/goals/m4";
import * as React from 'react';
export default {
  goals,
  React
};